// extracted by mini-css-extract-plugin
export default {"h4":"styles_h4__LzCQD"};